import {
  SYSTEM_GET_ALL_POSITION_TYPE_BEGIN,
  SYSTEM_GET_ALL_POSITION_TYPE_SUCCESS,
  SYSTEM_GET_ALL_POSITION_TYPE_FAILURE,
  SYSTEM_GET_ALL_POSITION_TYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllPositionType(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEM_GET_ALL_POSITION_TYPE_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
          request({
            method:'post',
            url:'/api/b/positionType/all',
          }).then( data => {
              dispatch({
                  type: SYSTEM_GET_ALL_POSITION_TYPE_SUCCESS,
                  data: data,
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: SYSTEM_GET_ALL_POSITION_TYPE_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });

    return promise;
  };
}

function convertOriginToTree(nodeList){
  let tree = [];
  for (let node of nodeList){
    if (node.pid == -1){
      let treeChilds = generateOriginSubTree(node,nodeList);
      console.log(treeChilds.length > 0)
      if (treeChilds.length > 0){
        node.children = treeChilds;
      }else {
        node.children = undefined;
      }
      tree.push(node);
    }
  }
  return tree;
}


 
  

function generateOriginSubTree(treeNode,nodelist){
    let childs = [];
    for (let node of nodelist){
      if (node.pid == treeNode.id){
        let nodeChilds = generateOriginSubTree(node,nodelist);
        if (nodeChilds.length > 0){
          node.children = nodeChilds;
        }else {
          node.children = undefined;
        }
        childs.push(node);
      }
    }
    return childs;
}

 

function convertToTree(nodeList){
  let tree = [];
  for (let node of nodeList){
    if (node.pid == -1){
      let treeChilds = generateSubTree(node,nodeList);
      node.children = treeChilds;
      
      tree.push(convertTreeComponetNode(node));
    }
  }
  return tree;
}

function generateSubTree(treeNode,nodelist){
    let childs = [];
    for (let node of nodelist){
      if (node.pid == treeNode.id){
        let nodeChilds = generateSubTree(node,nodelist);
        node.children = nodeChilds;
        childs.push(convertTreeComponetNode(node));
      }
    }
    return childs;
}

 

function convertTreeComponetNode(treeNode){
   return {
      title: treeNode.typeName,
      value: treeNode.id,
      key: treeNode.id,
      children:treeNode.children,
   }
}

  
 

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllPositionTypeError() {
  return {
    type: SYSTEM_GET_ALL_POSITION_TYPE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_GET_ALL_POSITION_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllPositionTypePending: true,
        getAllPositionTypeError: null,
      };

    case SYSTEM_GET_ALL_POSITION_TYPE_SUCCESS:
      // The request is success
      let positionTypeTree = convertToTree(action.data.list);
      let originPositionTypeTree = convertOriginToTree(action.data.list);
      let byId = {};
      action.data.list.forEach(item => {
          byId[item.id] = item;
      });

      return {
        ...state,
        getAllPositionTypePending: false,
        getAllPositionTypeError: null,
        positionTypeTree:{
          title: "根",
          value: -1,
          key: -1,
          children:positionTypeTree,
        },
        originPositionTypeTree:originPositionTypeTree,
        allTypeById:byId,
        positionTypeById: byId
      };

    case SYSTEM_GET_ALL_POSITION_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllPositionTypePending: false,
        getAllPositionTypeError: action.data.error,
      };

    case SYSTEM_GET_ALL_POSITION_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllPositionTypeError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/getAllPositionType.js